import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import axios from 'axios';
import { AppContext } from "./context/applicationContext";
import * as routes from './constants/routes';
import { Redirect } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import * as db from './db/db';
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';


const env = process.env.NODE_ENV;

const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing(1) * 3,
    marginRight: theme.spacing(1) * 3,
    [theme.breakpoints.up(400 + theme.spacing(1) * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(1) * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(1) * 2}px ${theme.spacing(1) * 3}px ${theme.spacing(1) * 3}px`,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(1) * 3,
    backgroundColor: '#3a3f4b'
  },
});

class HomeLogin extends Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = { username: '', password: '', errorMsg: false, redirect: false, disableBtn: false };
    this.loginForm = this.loginForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {

      if (this.context.userId !== null) {
        db.idbMethods.get(this.context.userId, db.userInfo).then((userInfo) => {
          if (userInfo && userInfo.userId && userInfo.userPrimaryCompany != null && userInfo.userPrimaryCompany.companyURL !== null && userInfo.userId !== undefined && userInfo.userPrimaryCompany.companyURL !== undefined) {
            this.setState({ userId: userInfo.userId, userSite: userInfo.userPrimaryCompany.companyURL});
            this.setState({ redirect: true });
          }
        });

      }else {
        //this.logOut();
     }

  }

  logOut = () => {
    this.context.setStateCustom('userId', null);
    db.idbMethods.clear(db.userInfo);
    db.idbMethods.clear(db.holidaysForApprove);
    db.idbMethods.clear(db.holidaysForApproveList);
    db.idbMethods.clear(db.myHolidays);
    this.setState({ redirect: true });
}

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
    this.context.setStateCustom([event.target.name], event.target.value);
    if (this.state.password !== '' && this.state.username !== '') {
      // this.setState({disableBtn:false});
    } else {
      //  this.setState({disableBtn:true});
    }
  }

  loginForm(e) {
    e.preventDefault();
    this.setState({ disableBtn: true });
    //const link = env === 'development' ? 'http://sf-spsdev07.lirex.com:42325/api/Token/CheckUser' : '/api/loginForm';
    const link = baseUrl + `/api/loginForm`;
    const isMobileDevice = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    };
    axios.post(link,
      {
        "UserName": this.state.username.toLowerCase(),
        "Password": this.state.password,
        "IsMobile": true,
        "IsPWAMobile": isMobileDevice
      }
      , { headers: headers })
      .then(res => {
        if ( res && res.status === 200) {
          this.context.setStateCustom('userId', res.data.userId);
          this.context.setStateCustom('token', res.data.Token);
          this.context.setStateCustom('expireIn', res.data.Expires);
          this.context.setStateCustom('userName', res.data.userName);
          this.context.setStateCustom('userId', res.data.userId);
         
          this.context.setStateCustom('userSite', res.data.userPrimaryCompany.companyURL);
         // console.log('>>>>>>>>>>>22222222',res.data)
         // console.log('>>>>>>>>>>>',this.context)
          db.idbMethods.set(res.data, db.userInfo).then((res) => {
           
            this.setState({ redirect: true });
          }).catch(error => {
            console.log(error);
          });
        }
      }).catch(error => {
        console.log('error', error);
        var errorObj =error;
        if(errorObj && errorObj.response){
        if (errorObj.response.status === 401) {
          this.props.enqueueSnackbar('Грешно потребителско име или парола!', { variant: "error" });
        }
        else if (errorObj.response.status === 404) {
          this.props.enqueueSnackbar('Невалиден потребител!', { variant: "error" });
        } else if (errorObj.response.status === 500) {
          this.props.enqueueSnackbar('Възникна грешка на сървърът!', { variant: "error" });
        } else {
          this.props.enqueueSnackbar('Възникна грешка!', { variant: "error" });
        }
      }
        this.setState({ disableBtn: false });
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={routes.MY_HOLIDAYS} />
    }
    return (
      <main className={this.props.classes.main}>
        <CssBaseline />
        <Paper className={this.props.classes.paper}>
          <Avatar className={this.props.classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Вход в отпуски
        </Typography>
          <form className={this.props.classes.form} onSubmit={(event) => this.loginForm(event)}>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="email">Лирекс потребител</InputLabel>
              <Input id="email" name="username" autoComplete="email" placeholder='(пример: "tdimitrov")' autoFocus onChange={(event) => this.handleChange(event)} value={this.state.username} />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password">Парола</InputLabel>
              <Input name="password" type="password" id="password" autoComplete="current-password" onChange={this.handleChange} value={this.state.password} />
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={this.props.classes.submit}
              disabled={this.state.disableBtn}
            >
              Вход
          </Button>
          </form>
        </Paper>
      </main>
    );
  }
}


HomeLogin.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withSnackbar(HomeLogin));
